var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InlineList',{attrs:{"items":_vm.common},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var groupItem = ref.item;
return [(Array.isArray(groupItem))?_c('InlineList',{attrs:{"items":groupItem,"separator":"comma"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('PreserveLine',[_c('BasicLink',{attrs:{"title":item.title,"href":item.href,"appearance":_vm.appearance}})],1)]}}],null,true)}):_c('BasicLink',{attrs:{"title":groupItem.title,"href":groupItem.href,"appearance":_vm.appearance}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }